import {
  BpOptionGroups,
  BpOptions,
  SelectedOptionGroups,
} from '../../../../services/database/mco/schema/public';
import { AssocBpOptionGroup, bpOptionUtil } from './bp-option.util';

export const selectedOptionGroupUtil = {
  makeSelectedBpOptionIds(
    {
      selected_option_group,
      bp_option_groups,
    }: { selected_option_group: SelectedOptionGroups; bp_option_groups: AssocBpOptionGroup[] },
    selected_bp_option_id: number,
  ): number[] {
    const all_bp_option_ids = bpOptionUtil.getAllBpOptionIdsByBpOptionId(
      bp_option_groups,
      selected_bp_option_id,
    );
    if (!selected_option_group.bp_option_ids) return [];
    const bp_option_ids = selected_option_group.bp_option_ids.filter(
      (bp_option_id) => !all_bp_option_ids.includes(bp_option_id),
    );
    return bp_option_ids.concat(selected_bp_option_id);
  },
  getSelectedOptionGroupAndOptionByDevName(
    bp_option_groups: AssocBpOptionGroup[],
    selected_bp_option_ids: number[],
    dev_name: string,
  ): { bp_option_group: BpOptionGroups; bp_option: BpOptions } | undefined {
    const bp_option_group = bpOptionUtil.getBpOptionGroupByDevName(bp_option_groups, dev_name);
    if (!bp_option_group) return;
    const bp_option = bpOptionUtil.getBpOptionByIds(bp_option_group, selected_bp_option_ids);
    if (!bp_option) return;
    return { bp_option_group, bp_option };
  },
  getSelectedBpOptions(
    bp_option_groups: AssocBpOptionGroup[],
    selected_bp_option_ids: number[],
  ): (BpOptions | undefined)[] {
    return bp_option_groups.map((bp_option_group) => {
      const bp_option = bpOptionUtil.getBpOptionByIds(bp_option_group, selected_bp_option_ids);
      return bp_option;
    });
  },
};
